import { ICardTranslation } from "containers/Card/store/CardState";
import {
  ICajitaLayoutTranslation,
  ICardAsyncFormTranslation,
  ICardSubscriptionAsyncFormTranslation,
  ICashFormTranslation,
  ITransferFormTranslation,
} from "root/shared/MultiLanguage";
import { ITransferSubscriptionTranslation } from "types/cajita_store";
import { IPayoutsCashTranslation } from "types/payouts_cash_form_props";

/**
 * Portuguese translation for Cajita Layout
 */
const notAvailablePortugueseMessage: string =
  "Não foi possível criar a transação. Tente novamente mais tarde ou entre em contato com a empresa.";
const identificationNumber: string = "Número de identificação";

const primeiroNome: string = "Primeiro nome";
const correio: string = "Correio eletrônico";
const card: string = "Pagamento com cartão";
export const portugueseCajitaLayout: ICajitaLayoutTranslation = {
  payButton: ["Pagar"],
  payoutButton: ["Solicitar pagamento"],
  payinButton: ["Gerar ordem de pagamento"],
  selectPaymentMethod: ["Selecione a forma de pagamento"],
  changePaymentMethod: ["Alterar forma de pagamento"],
  selectYourBank: ["Selecione seu banco"],
  subscriptionButton: ["Subscrever"],
  selectorMethods: {
    card: [card],
    credit_card: [card],
    debit_card: [card],
    transfer: ["Pagamento com transferência"],
    transfer_subscription: ["Débito recorrente"],
    transfer_mxn: ["SPEI (Transferência Bancária)"],
    cash: ["Pagamento em dinheiro"],
    payouts_cash: ["Pagamentos em dinheiro"],
    card_async: ["Pagamento com Webpay"],
    card_dynamic: ["Pago com cartão de crédito"],
    card_subscription_dynamic: ["Pagamento com assinatura"],
    card_subscription_async: ["Assinatura de cartão"],
  },
  notAvailable: ["Desculpe, Kushki está indisponível no momento"],
  notAvailableTransfer: [notAvailablePortugueseMessage],
  notAvailableCash: [notAvailablePortugueseMessage],
  notAvailableCardAsync: [notAvailablePortugueseMessage],
  notAvailableCardSubscriptionAsync: [notAvailablePortugueseMessage],
  overlayMessageTitle: ["Um momento"],
  overlayMessageSubtitle: ["Processando seu pagamento"],
  cashHelperMessage: [
    "Insira seu e-mail e clique em “Gerar ordem de pagamento para receber os dados necessários para fazer sua transferência",
  ],
  transferHelperMessage: [
    "Ingresa tu e-mail y haz clic en “Generar orden de pago para recibir los datos necesarios para realizar tu transferencia.",
  ],
  payinTotalAmountMessage: [
    // tslint:disable-next-line:no-invalid-template-strings
    "Seu pedido de pagamento será gerado por ${totalAmount}",
  ],
  footer: {
    learnMore: ["Ler mais"],
    secureMessage: [
      "Esse pagamento é processado com segurança pela Kushki, um provedor de pagamentos PCI nível 1.",
    ],
    changeLanguage: ["Mudar idioma"],
    cardDocumentation: ["Como fazer um pagamento com cartão de crédito?"],
    pseDocumentation: ["Como fazer um pagamento com PSE?"],
  },
  languages: {
    en: ["Inglês"],
    es: ["Espanhol"],
    br: ["Português"],
  },
};

/**
 * Portuguese translation for cash form
 */

export const portugueseCashForm: ICashFormTranslation = {
  description: ["Descrição do produto"],
  identificationInput: ["Número do documento"],
  lastNameInput: ["Sobrenome"],
  nameInput: [primeiroNome],
  email: [correio],
};

/**
 * Portuguese translation for card form
 */

export const portugueseCardForm: ICardTranslation = {
  cardHolder: ["Nome e sobrenome"],
  cardNumber: ["Número de cartão"],
  expDate: ["MM/AA"],
  cardCVC: ["CVC"],
  email: [correio],
  deferredOptionsComponent: {
    deferredTypeSelectLabel: ["Tipo diferido"],
    monthsSelectLabel: ["Meses"],
    monthsOfGraceSelectLabel: ["Meses de Graça"],
    toggleTitle: ["Parcelar"],
  },
  invalidOtpMessage: ["OTP inválido"],
  otpKushkiTitle: [
    "Verifique a notificação que seu banco lhe enviou por SMS ou e-mail.",
  ],
  otpDinersTitle: [
    "A chave de segurança temporária foi enviada para o seu e-mail ou telefone celular registrado.",
  ],
  messageDiners: ["Digite sua senha temporária abaixo:"],
  messageKushki: [
    "Fizemos uma pequena cobrança em seu cartão como HELP_KUSHKI VERIFICATION, que será revertida imediatamente. A cobrança efetuada possui 3 (três) algarismos, que devem ser inseridos abaixo:",
  ],
  howItWorks: ["Como funciona?"],
  otpTitle: ["Verificação"],
  tryWithAnotherCard: ["Tente outro cartão"],
  otpButtonText: ["Confirmar código"],
  helpText: [
    "O código de segurança que você deve inserir nas caixas é um valor aleatório que você receberá por SMS ou email. " +
      "Esse valor será debitado no seu cartão e será revertido imediatamente sem gerar um custo adicional para sua compra.",
  ],
  exampleText: {
    firstPhrase: ["Se a cobrança notificada por email ou SMS for de"],
    secondPhrase: [", você deve inserir as caixas:"],
    forExample: ["Por exemplo"],
  },
  transactionResume: ["Resumo da transação"],
  valueToPay: ["Valor a pagar:"],
  numberOffees: ["Número de cotas:"],
  amountPerFee: ["Valor por parcela:"],
  back: ["Voltar"],
  continue: ["Continuar"],
  commission: {
    link: ["Veja detalhes de comissões\n"],
    title: ["Detalhe da comissão"],
    text: ["Veja como os valores de sua compra serão divididos:"],
  },
  exceededRetries: {
    title: ["Muitas tentativas falhas"],
    description: [
      "A verificação não pôde ser concluída porque você falhou em muitas tentativas. Volta a tentar",
    ],
    note: [
      "*Lembre-se que o valor que foi cobrado ou debitado do seu cartão será estornado imediatamente",
    ],
    button: ["Tente outra carta"],
  },
};

/**
 * Portuguese translation for card async form
 */
export const portugueseCardAsyncForm: ICardAsyncFormTranslation = {
  emailInput: [correio],
};

/**
 * Portuguese translation for card async form
 */
export const portugueseCardSubscriptionAsyncForm: ICardSubscriptionAsyncFormTranslation = {
  emailInput: [correio],
  cardNumber: ["Número de cartão"],
};

/**
 * Portuguese translation for transfer form
 */
export const portugueseTransferForm: ITransferFormTranslation = {
  documentEmailInput: ["Mail"],
  documentNumberInput: [identificationNumber],
  paymentDescriptionInput: ["Descrição do produto"],
  bankListSelectLabel: ["Débito da sua conta corrente ou poupança"],
  userTypeRadioGroupLabel: ["Tipo de pessoa"],
  userTypeRadioGroup: {
    "0": ["Natural"],
    "1": ["Jurídico"],
  },
};

/**
 * Porguese translation for transfer subscription form
 */

export const portugueseTransferSubscriptionForm: ITransferSubscriptionTranslation = {
  name: [primeiroNome],
  lastName: ["Sobrenome"],
  documentType: ["Tipo de identificação"],
  documentNumber: [identificationNumber],
  accountTypeLabel: ["Tipo de conta"],
  accountType: {
    "01": ["Poupança"],
    "02": ["Corrente"],
  },
  bankId: ["Banco"],
  accountNumber: ["Numero de conta"],
  email: [correio],
  waitMoment: ["Um momento!"],
  confrontaDescription: [
    "Por razões de segurança, precisamos validar alguns dados adicionais, mas não se preocupe com isso,",
  ],
  confrontaDescriptionStrong: ["faremos isso apenas uma vez."],
  howItWorks: ["Como funciona?"],
  dataVerificationLabel: ["Verificação de dados"],
  confirmButtonText: ["Confirme"],
  cancelButtonText: ["Cancelar"],
  adviceDocumentNumber: [
    "Preencha as seguintes informações, relacionadas ao documento de identidade:",
  ],
  continueButtonText: ["Continuar"],
  selectYourDepartment: ["Selecione seu departamento..."],
  selectYourCity: ["Selecione sua cidade..."],
  cityLabel: ["Cidade"],
  departmentLabel: ["Departmento"],
  expeditionDateLabel: ["Data de expedição"],
  howItWorksMessage: [
    "Após a validação dos seus dados de identidade, iremos apresentar-lhe várias questões sobre os seus dados pessoais e / ou bancários que deverá responder corretamente para efetuar a transação.",
  ],
};

/**
 * Portuguese PayoutsCashForm for transfer form
 */

export const portuguesePayoutsCashForm: IPayoutsCashTranslation = {
  nameInput: [primeiroNome],
  lastNameInput: ["Sobrenome"],
  identificationInput: [identificationNumber],
  description: ["Descrição"],
  email: [correio],
};



// WEBPACK FOOTER //
// ./src/shared/Languages/Portugues.ts